<template>
  <atoms-card
    class="text-center"
    size="md"
    :class="{
      'bg-blue-900 text-white px-5 pb-6': theme === 'dark',
      'text-dark bg-white': theme === 'default'
    }"
    :rounded="theme === 'dark' ? 'xl' : 'lg'"
    :shadow="theme === 'dark' ? 'none' : 'xl'"
    theme="plain"
  >
    <!-- eslint-disable vue/no-v-html -->
    <p
      :class="{
        'text-yellow-600': theme === 'dark'
      }"
      class="mt-0 mb-4 text-1.5xl leading-6"
      v-html="title"
    >
    </p>

    <hr
      v-show="theme === 'default'"
      class="border-0 border-b border-dark"
    />

    <p class="text-sm leading-6 mt-2 font-bold">
      {{ subTitle }}
    </p>

    <div
      class="grid grid-cols-4 md:grid-cols-10 lg:grid-cols-4 gap-y-2.5 mt-4"
      :class="{
        'gap-x-2': theme == 'default',
        'gap-x-4': theme == 'dark'
      }"
    >
      <div
        v-for="n in 44"
        :key="n"
        class="col-lg-3 col-md-3 col-sm-3"
      >
        <atoms-cta
          :id="`cta-sidebar-${ n + 39 }`"
          target="_self"
          :to="`${ formUrl }?age=${ n === 1 ? '35' : n === 44 ? '84' : n + 39 }`"
          :theme="theme === 'dark' ? 'tertiary2' : 'primaryWhite'"
          size="medium"
          rounded="standard"
        >
          {{ n === 1 ? '<' : '' }}
          {{ n + 39 }}
          {{ n === 44 ? '>' : '' }}
        </atoms-cta>
      </div>
    </div>

    <p
      class="mb-0 font-thin pt-6"
      :class="{
        'text-sm' : theme === 'default',
        'text-xs': theme === 'dark'
      }"
    >
      {{ disclaimer }}
    </p>
  </atoms-card>
</template>

<script setup>
defineOptions({
  name: 'MoleculesAgeCta'
})

const props = defineProps({
  title: {
    type: String,
    default: '<strong>Select your age</strong> <br class="hidden lg:block"/> <span class="text-1.5xl"> and </span> <br class="block md:hidden"/> <strong>compare now!</strong>'
  },

  subTitle: {
    type: String,
    default: 'We’ll show best quotes for you'
  },

  componentVertical: {
    type: String,
    default: 'Health Insurance'
  },

  customComponent: {
    type: Object,
    default: () => ({})
  },

  theme: {
    type: String,
    default: 'default'
  },

  disclaimer: {
    type: String,
    default: '*Average savings based on 136,746 customers between 1 Jan 2018 - 23 December 2022'
  }
})

const formUrlMap = {
  'Health Insurance': '/health-insurance/quote/form/step1/',
  'Life Insurance': '/life-insurance/quote/form/step1/',
  Energy: '/energy/quote/form/step1/',
  'Home Loans': '/home-loans/quote/form/step1/'
}

const formUrl = computed(() => {
  const { componentVertical, customComponent } = props
  const customUrl = customComponent.to

  if (!customUrl) {
    return formUrlMap[componentVertical] || '/'
  }

  return customUrl
})
</script>
